import { useContext } from 'react';

import { AuthContext } from '../contexts/AuthContext';

export default () => useContext(AuthContext);
